import React, { useState, useEffect } from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';

const Sub4IssueExplanation = (props) => {
    const { shipId, shipName, titleWidth, disabled, returnInputValue, changeData, data, z } = props;

    useEffect(() => {
    }, []);

    const getInitialDataArray = () => {
        const sub4 = data.sub4_issue_explanation || [];
        const initialDataArray = sub4.filter((o) => o.zone_name === z );

        if (initialDataArray.length === 0) {
            initialDataArray.push({
                issue_reason: '',
                zone_name: z,
                ship_id: shipId || "",
                ship_name: shipName || "",
                is_delete: false,
            });
        }
        return initialDataArray;
    };

    const dataAry = getInitialDataArray();

    const addRow = () => {
        const newRow = { issue_reason: '', zone_name: z, ship_id: shipId || "", ship_name: shipName || "", is_delete: false, };
        changeData({ label: 'sub4_issue_explanation', data: [...dataAry, newRow] });
    };

    const delRow = (index) => {
        const newDataArray = [...dataAry];

        if (newDataArray[index]['id']) {
            newDataArray[index].is_delete = true;
        } else {
            newDataArray.splice(index, 1);
        }
        changeData({ label: 'sub4_issue_explanation', data: newDataArray });
    };

    const handleIssueReasonChange = (index, newValue) => {
        const newDataAry = [...dataAry];
        newDataAry[index].issue_reason = newValue;
        changeData({ label: 'sub4_issue_explanation', data: newDataAry });
    };

    return (
        <>
            {dataAry.map((o, i) => (
                !o.is_delete && 
                <EAA_Row key={`PPDaily_Area_Schedule_Sub4_${z}_${i}`}>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <EAA_TitleText width={titleWidth + 20} />
                            <div style={{ marginLeft: 8, marginRight: 8 }}>{`(${i + 1})`}</div>
                            <EAA_Input
                                displayBorder
                                disabled={disabled}
                                hint="詳答"
                                marginRight={8}
                                value={returnInputValue(o.issue_reason)}
                                onChange={(data) => handleIssueReasonChange(i, data)}
                            />
                            <EAA_Add_Btn
                                disabled={disabled}
                                del={i > 0}
                                onClick={i > 0 ? () => delRow(i) : addRow}
                            />
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>
            ))}
        </>
    );
};

export default Sub4IssueExplanation;